import { memoizeOnClient } from 'wanderu-utils';

function createSelectorFactory(factoryFn, limit = 750) {
    let memoizedFactory;

    return (state, ...args) => {
        if (!memoizedFactory) {
            memoizedFactory = memoizeOnClient(factoryFn, { limit });
        }

        return memoizedFactory(...args)(state);
    };
}

export {
    createSelectorFactory,
};
